import { render, staticRenderFns } from "./data-processing-tmc-page.vue?vue&type=template&id=9f607320&scoped=true"
import script from "./data-processing-tmc-page.vue?vue&type=script&lang=js"
export * from "./data-processing-tmc-page.vue?vue&type=script&lang=js"
import style0 from "./data-processing-tmc-page.vue?vue&type=style&index=0&id=9f607320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f607320",
  null
  
)

export default component.exports